"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurnMeterChangedEventArgs = void 0;
const EventType_1 = require("../EventType");
class TurnMeterChangedEventArgs {
    constructor(value) {
        this.value = value;
        this.__type = EventType_1.EventType.TurnMeterChanged;
        this.__typeName = "TurnMeterChanged";
    }
}
exports.TurnMeterChangedEventArgs = TurnMeterChangedEventArgs;
